export default {
  TableHeadBankAccount: [
    [
      {
        displayName: 'bankaccount.banktablehead.name',
      },
      {
        displayName: 'bankaccount.banktablehead.accname',
      },
      {
        displayName: 'bankaccount.banktablehead.accnumber',
      },
      {
        displayName: 'bankaccount.banktablehead.edit',
      },
      {
        displayName: 'bankaccount.banktablehead.delete',
      },
    ],
  ],
};
